import { systemLutsStore } from '@/services/indexedDB.service';
// import LUTCubeLoader from '@/assets/js/loaders/LUTCubeLoader';
import { LUTCubeLoader } from 'postprocessing';
import { LinearFilter } from 'three';
import { luts } from '@/assets/js/Boot';

export default class Luts {
	constructor() {
		this.lutsLoadedInterval;
		this.IDT = config.IDT; // loading from config
		this.IDTluts = []; // fetched IDT luts
		this.ODTluts = []; // fetched ODT luts
		this.ODT = config.ODT; // loading from config
		this.LUTcontrols = []; // LUT controls
		this.customLUT = {}; // User's LUTs
		this.LUTsliders = []; // LUT sliders (pseudo controls)
		this.loaded = {
			// identity: { required: true, status: false },
			// creative: {required: true, status: false},
			IDT: { required: true, status: false },
			ODT: { required: true, status: false },
			LUTcontrols: { required: false, controls: [] },
			LUTsliders: { required: false, controls: [] },
			customLUT: { required: false, initialLoad: true, folders: [] },
			customLutV2: { required: false, initialLoad: true, folders: [] },
		};
		this.IPP2 = [];
		this.davinci = [];
		this.logc4 = [];
		this.CO = [];
		this.COStep1Result = [];
		this.customLutsBlockColourSpaceLuts = [];
		this.customLutV2BlockIdentityLuts = [];
	}

	async prepareExportLuts(data) {
		let metaData = {
			meta: {
				createdBy: "# Created with: fylm.ai - Colour Grading and Collaboration Software in Cloud",
				website: "# Website: https://fylm.ai",
				title: `TITLE "${data.name}"`,
				description: data.description ? `# User META: ${data.description}` : false,
			},
			options: data.options,
		};

		let exportLuts = [];

		if (!luts.identity33) await this.fetchIdentityLUT(33);
		let exportData = await gpu.getExportData(33, "ACES", metaData);
		let contentMeta = this.getExportContentMeta(metaData, exportData.blocksData, 33);
		let contentPixels = this.getExportContentPixels(exportData.pixels);

		exportLuts.push(new File([contentMeta + contentPixels], `${data.name}.cube`, { type: "text/plain" }));

		return exportLuts;
	}

	async prepareDownloadLuts(data) {
		let metaData = {
			meta: {
				createdBy: "# Created with: fylm.ai - Colour Grading and Collaboration Software in Cloud",
				website: "# Website: https://fylm.ai",
				...(!data.options.CO) && {title: `TITLE "${data.name}"`},
				description: data.description ? `# User META: ${data.description}` : false,
			},
			options: data.options,
		};

		let exportLuts = [];
		let payload = {};

		// VLT export
		if (data.options.vlt) {
			if (!luts.identity17) await this.fetchIdentityLUT(17);

			let exportData = await gpu.getExportData(17, "vlt");
			payload.vlt_pixels = exportData.pixels.toString();
			payload.vlt_meta = this.getExportContentMetaFoVlt( 17);
		}

		// IPP2 export
		if (data.options.IPP2) {
			if (!luts.identity33) await this.fetchIdentityLUT(33);
			// if (!this.IPP2[0]) await this.fetchIPP2IDT();
			if (!this.IPP2[0]) await this.fetchIPP2ODT();

			let exportData = await gpu.getExportData(33, "IPP2", metaData);
			payload.ipp2_pixels = exportData.pixels.toString();
			payload.ipp2_meta = this.getExportContentMeta(metaData, exportData.blocksData, 33, "skip");
		}

		// davinci export
		if (data.options.davinci) {
			if (!luts.identity33) await this.fetchIdentityLUT(33);
			if (!this.davinci[0]) await this.fetchDavinciIDT();
			if (!this.davinci[1]) await this.fetchDavinciODT();

			let exportData = await gpu.getExportData(33, "davinci", metaData);
			payload.davinci_pixels = exportData.pixels.toString();
			payload.davinci_meta = this.getExportContentMeta(metaData, exportData.blocksData, 33, "skip");
		}

		// logc4 export
		if (data.options.logc4) {
			if (!luts.identity33) await this.fetchIdentityLUT(33);
			if (!this.logc4[0]) await this.fetchLogC4IDT();
			if (!this.logc4[1]) await this.fetchLogC4ODT();

			let exportData = await gpu.getExportData(33, "logc4", metaData);
			payload.logc4_pixels = exportData.pixels.toString();
			payload.logc4_meta = this.getExportContentMeta(metaData, exportData.blocksData, 33, "skip");
		}

		// Capture One export
		if (data.options.CO) {
			if (!luts.identity33) await this.fetchIdentityLUT(33);
			if (!this.CO.find(lut => lut.title == `Capture One/${data.options.camera.lut}`)) await this.fetchCaptureOneIdentityLut(data.options.camera);

			let exportData = await gpu.getExportData(33, "CO_step1", metaData);
			payload.cube_pixels = exportData.pixels.toString();
			payload.cube_meta = this.getExportContentMeta(metaData, exportData.blocksData, 33, "skip");

			response = await vm.$store.dispatch('Files/downloadLuts', payload);
			const cubeFile = new File([response.data.cube], `sRGB-LMT-sRGB.cube`, { type: 'text/plain' });
			luts.COStep1Result = [];
			await luts.load([cubeFile], luts.COStep1Result);

			exportData = await gpu.getExportData(33, "CO_step2", metaData);
			payload.cube_pixels = exportData.pixels.toString();
		}

		const isACESExport = ![
			data.options.vlt,
			data.options.IPP2,
			data.options.davinci,
			data.options.logc4,
			data.options.CO,
		].includes(true);

		// ACES export
		if (isACESExport) {
			if (!luts.identity33) await this.fetchIdentityLUT(33);
			let exportData = await gpu.getExportData(33, "ACES", metaData);
			payload.cube_pixels = exportData.pixels.toString();
			payload.cube_meta = this.getExportContentMeta(metaData, exportData.blocksData, 33);
		}

		let response;

		if (data.options.CO) {
			response = await vm.$store.dispatch('Files/downloadCO', payload);
			if (!response) {
				vm.$snackbar("Download of Capture One Style failed.", "error");
				return;
			}
		} else {
			response = await vm.$store.dispatch('Files/downloadLuts', payload);
			if (!response) {
				vm.$snackbar("Download of luts failed.", "error");
				return;
			}
		}

		if (data.options.vlt) exportLuts.push(new File([response.data.vlt + "\n"], `VLog-${data.name}-Rec709.vlt`, { type: "text/plain" }));
		if (data.options.IPP2) exportLuts.push(new File([response.data.ipp2], `RWG-${data.name}-RWG.cube`, { type: "text/plain" }));
		if (data.options.davinci) exportLuts.push(new File([response.data.davinci], `DWG-${data.name}-DWG.cube`, { type: "text/plain" }));
		if (data.options.logc4) exportLuts.push(new File([response.data.logc4], `LogC4-${data.name}-LogC4.cube`, { type: "text/plain" }));
		if (data.options.CO) exportLuts.push(new File([response.data], `${data.name}.icc`, { type: "text/plain" }));
		if (isACESExport) {
			if (data.options.xmp) exportLuts.push(new File([response.data.cube], `${data.name}.cube`, { type: 'text/plain' }))
			else {
				const IDTname = data.options.ACESinput ? (luts.IDT.find(lut => lut.value == lutify.selectedIDT.value).exportName || luts.IDT.find(lut => lut.value == lutify.selectedIDT.value).label) : 'ACEScct'
				const ODTname = data.options.ACESoutput ? (luts.ODT.find(lut => lut.value == lutify.selectedODT.value).exportName || luts.ODT.find(lut => lut.value == lutify.selectedODT.value).label) : 'ACEScct'
				exportLuts.push(new File([response.data.cube], `${IDTname}-${data.name}-${ODTname}.cube`, { type: 'text/plain' }))
			}
		}

		return exportLuts;
	}

	getExportContentMeta(data, blocksData, lutSize, skip = false) {
		let blocksMeta = "# META\n";

		if (lutify.fixBlueLightArtifacts) {
			blocksMeta += `# Option: Fix blue light artifacts\n`;
		}

		if (lutify.gamutCompress) {
			blocksMeta += `# Option: Gamut compress\n`;
		}

		blocksData.forEach((block, i) => {
			if (block.type == "fixed" && skip) return;
			blocksMeta += skip ? `# Block ${i}: ` : `# Block ${i + 1}: `;

			// IDT & ODT
			if (block.type == "fixed") {
				blocksMeta += `${block.name} | `;
				blocksMeta += `${block.values.label}\n`;
				return;
			} else if (block.control == "LUTcontrols") {
				blocksMeta += `LUT | ${block.name}: ${block.selectedPreviewName} (${block.opacity}%)`;
				blocksMeta += "\n";
			} else if (block.control == "customLUT" || block.control == 'CustomLutV2') {
				blocksMeta += `Custom LUT | Folder: ${JSON.stringify(block.folder)} | LUT: ${JSON.stringify(block.lut)} | ColorSpace: ${JSON.stringify(block.colorSpace)} | Opacity: ${block.opacity}%`
				blocksMeta += "\n";
			} else if (block.name == "magicMode") {
				blocksMeta += "Legacy Magic Mode | ";
				block.selectedPreviewName.forEach((selectedPreviewName, selectedIndex) => {
					if (selectedPreviewName) {
						blocksMeta += `${_Adjustments.magicMode.controls[selectedIndex].category}: ${selectedPreviewName} (${block.opacity[selectedIndex]}%) `;
						if (block.selectedPreviewName.length - 1 !== selectedIndex) blocksMeta += "| ";
					}
				});
				blocksMeta += "\n";
			} else if (block.name == "AIMagicMode") {
				blocksMeta += "Magic Mode | ";
				block.selectedPreviewName.forEach((selectedPreviewName, selectedIndex) => {
					if (selectedPreviewName) {
						blocksMeta += `${_Adjustments.AIMagicMode.controls[selectedIndex].category}: ${selectedPreviewName} (${block.opacity[selectedIndex]}%) `;
						if (block.selectedPreviewName.length - 1 !== selectedIndex) blocksMeta += "| ";
					}
				});
				blocksMeta += "\n";
			} else {
				blocksMeta += `${block.name} | Blending Mode: ${block.blendingModeName} | `;
				blocksMeta += JSON.stringify(block.values);
				blocksMeta += "\n";
			}
		});

		// Appending some meta on top in file
		let text = `${data.meta.createdBy} \n`;
		text += `${data.meta.website} \n\n`;
		text += blocksMeta + "\n";

		if (data.meta.description) text += `${data.meta.description}\n\n`;

		// text += `SOURCE ${JSON.stringify(blocksData)}`;
		// text += "\n\n";

		if (data.meta.title) text += `${data.meta.title} \n\n`;
		text += "LUT_3D_SIZE " + lutSize + "\n";

		return text;
	}

	getExportContentMetaFoVlt(lutSize) {
		let blocksMeta = "# panasonic vlt file version 1.0\n";
		blocksMeta += '# source vlt file ""\n';
		blocksMeta += "LUT_3D_SIZE " + lutSize + "\n";

		return blocksMeta;
	}

	getExportContentPixels(pixels, vlt = false) {
		let content = "";

		if (!vlt) {
			for (let j = 0; j < pixels.length; j += 4) {
				content +=
					pixels[j].toFixed(6).toString() + " " + pixels[j + 1].toFixed(6).toString() + " " + pixels[j + 2].toFixed(6).toString() + "\n";
			}
		} else {
			for (let j = 0; j < pixels.length; j += 4) {
				content +=
					Math.min(4095, Math.max(0, Math.round(pixels[j] * 4095))).toString() +
					" " +
					Math.min(4095, Math.max(0, Math.round(pixels[j + 1] * 4095))).toString() +
					" " +
					Math.min(4095, Math.max(0, Math.round(pixels[j + 2] * 4095))).toString() +
					"\n";
			}
		}

		return content;
	}

	async fetchIdentityLUT(size) {
		let fetchedLUT = await systemLutsStore.getItem(`identity-${size}`);

		if (!fetchedLUT) {
			let fetchedLUTData = await vm.$store.dispatch("Projects/fetchSystemLuts", {
				type: "identity",
				category: `Identity-${size}x${size}x${size}.cube`,
			});

			fetchedLUT = await vm.$store.dispatch("Projects/fetchFile", fetchedLUTData.presignedUrl);
			fetchedLUT = new File([fetchedLUT], fetchedLUTData.fileName, { type: "text/plain" });

			await systemLutsStore.setItem(`identity-${size}`, fetchedLUT);
		}

		luts[`identity${size}`] = fetchedLUT;
	}

	async fetchIPP2ODT() {
		let fetchedLUT = await systemLutsStore.getItem("ACEScct-to-RWG"); // checking in indexedDB

		if (!fetchedLUT) {
			let fetchedLUTData = await vm.$store.dispatch("Projects/fetchSystemLuts", {
				type: "identity",
				category: "ACEScct-to-RWG.cube",
			});

			fetchedLUT = await vm.$store.dispatch("Projects/fetchFile", fetchedLUTData.presignedUrl);
			fetchedLUT = new File([fetchedLUT], fetchedLUTData.fileName, { type: "text/plain" });

			systemLutsStore.setItem("ACEScct-to-RWG", fetchedLUT);
		}

		await luts.load([fetchedLUT], luts.IPP2);
	}

	async fetchDavinciIDT() {
		let fetchedLUT = await systemLutsStore.getItem("DWG-to-ACEScct-v2"); // checking in indexedDB

		if (!fetchedLUT) {
			let fetchedLUTData = await vm.$store.dispatch("Projects/fetchSystemLuts", {
				type: "identity",
				category: "DWG-to-ACEScct-v2.cube",
			});

			fetchedLUT = await vm.$store.dispatch("Projects/fetchFile", fetchedLUTData.presignedUrl);
			fetchedLUT = new File([fetchedLUT], fetchedLUTData.fileName, { type: "text/plain" });

			systemLutsStore.setItem("DWG-to-ACEScct-v2", fetchedLUT);
		}

		await luts.load([fetchedLUT], luts.davinci);
	}

	async fetchDavinciODT() {
		let fetchedLUT = await systemLutsStore.getItem("ACEScct-to-DWG-v2"); // checking in indexedDB

		if (!fetchedLUT) {
			let fetchedLUTData = await vm.$store.dispatch("Projects/fetchSystemLuts", {
				type: "identity",
				category: "ACEScct-to-DWG-v2.cube",
			});

			fetchedLUT = await vm.$store.dispatch("Projects/fetchFile", fetchedLUTData.presignedUrl);
			fetchedLUT = new File([fetchedLUT], fetchedLUTData.fileName, { type: "text/plain" });

			systemLutsStore.setItem("ACEScct-to-DWG-v2", fetchedLUT);
		}

		await luts.load([fetchedLUT], luts.davinci);
	}

	async fetchLogC4IDT() {
		const lutName = 'LogC4-to-ACEScct';
		let fetchedLUT = await systemLutsStore.getItem(lutName);

		if (!fetchedLUT) {
			let fetchedLUTData = await vm.$store.dispatch("Projects/fetchSystemLuts", {
				type: "identity",
				category: `${lutName}.cube`,
			});

			fetchedLUT = await vm.$store.dispatch("Projects/fetchFile", fetchedLUTData.presignedUrl);
			fetchedLUT = new File([fetchedLUT], fetchedLUTData.fileName, { type: "text/plain" });

			systemLutsStore.setItem(lutName, fetchedLUT);
		}

		await luts.load([fetchedLUT], luts.logc4);
	}

	async fetchLogC4ODT() {
		const lutName = 'ACEScct-to-LogC4';
		let fetchedLUT = await systemLutsStore.getItem(lutName); // checking in indexedDB

		if (!fetchedLUT) {
			let fetchedLUTData = await vm.$store.dispatch("Projects/fetchSystemLuts", {
				type: "identity",
				category: `${lutName}.cube`,
			});

			fetchedLUT = await vm.$store.dispatch("Projects/fetchFile", fetchedLUTData.presignedUrl);
			fetchedLUT = new File([fetchedLUT], fetchedLUTData.fileName, { type: "text/plain" });

			systemLutsStore.setItem(lutName, fetchedLUT);
		}

		await luts.load([fetchedLUT], luts.logc4);
	}

	async fetchCaptureOneIdentityLut(camera = {}) {
		const folderName = 'Capture One';
		const categoryName = camera.name;
		const lutName = camera.lut;
		let fetchedLUT = await systemLutsStore.getItem(`${folderName}/${categoryName}`);

		if (!fetchedLUT) {
			let fetchedLUTData = await vm.$store.dispatch("Projects/fetchSystemLuts", {
				type: "identity",
				category: `${folderName}/${lutName}.cube`,
			});

			fetchedLUT = await vm.$store.dispatch("Projects/fetchFile", fetchedLUTData.presignedUrl);
			fetchedLUT = new File([fetchedLUT], fetchedLUTData.fileName, { type: "text/plain" });

			await systemLutsStore.setItem(`${folderName}/${categoryName}`, fetchedLUT);
		}

		await this.load([fetchedLUT], this.CO);
	}

	fetchAll() {
		return Promise.all([this.fetchIDTLUTs(), this.fetchODTLUTs()]);
	}

	async fetchIDTLUTs() {
		let fetchedLUTs = await systemLutsStore.getItem("IDT"); // checking in indexedDB

		if (!fetchedLUTs) {
			let fetchedLUTDataList = await vm.$store.dispatch("Projects/fetchSystemLuts", {
				type: "idt",
			});

			let promises = [];
			fetchedLUTDataList.forEach(LUT => {
				promises.push(vm.$store.dispatch("Projects/fetchFile", LUT.presignedUrl));
			});

			fetchedLUTs = await Promise.all(promises);

			fetchedLUTs.forEach((blob, key) => {
				fetchedLUTs[key] = new File([blob], fetchedLUTDataList[key].fileName, { type: "text/plain" });
			});

			systemLutsStore.setItem("IDT", fetchedLUTs);
		}

		await this.load(fetchedLUTs, luts.IDTluts);
		this.loaded.IDT.status = true;
	}

	async fetchODTLUTs() {
		let fetchedLUTs = await systemLutsStore.getItem("ODT"); // checking in indexedDB

		if (!fetchedLUTs) {
			let fetchedLUTDataList = await vm.$store.dispatch("Projects/fetchSystemLuts", {
				type: "odt",
			});

			let promises = [];
			fetchedLUTDataList.forEach(LUT => {
				promises.push(vm.$store.dispatch("Projects/fetchFile", LUT.presignedUrl));
			});

			fetchedLUTs = await Promise.all(promises);

			fetchedLUTs.forEach((blob, key) => {
				fetchedLUTs[key] = new File([blob], fetchedLUTDataList[key].fileName, { type: "text/plain" });
			});

			systemLutsStore.setItem("ODT", fetchedLUTs);
		}

		await this.load(fetchedLUTs, luts.ODTluts);
		this.loaded.ODT.status = true;
	}

	get(title, category) {
		return this[category].find(LUT => LUT.title == title);
	}

	async fetchLUTcontrols(controlData) {
		let store;
		if (controlData.control == "LUTcontrols") store = LUTcontrolsStore;
		else store = LUTslidersStore;

		let fetchedLUTs = await store.getItem(controlData.category);

		if (!fetchedLUTs) {
			let fetchedLUTDataList = [];

			if (controlData.product) {
				fetchedLUTDataList = await vm.$store.dispatch("Products/fetchLuts", controlData.product.id);
			} else {
				fetchedLUTDataList = await vm.$store.dispatch("Projects/fetchSystemLuts", {
					type: "controls",
					category: controlData.control == "LUTcontrols" ? "blocks/" + controlData.category : "sliders/" + controlData.category,
				});
			}

			let promises = [];
			fetchedLUTDataList.forEach(LUT => {
				promises.push(vm.$store.dispatch("Projects/fetchFile", LUT.presignedUrl));
			});

			fetchedLUTs = await Promise.all(promises);

			fetchedLUTs.forEach((blob, key) => {
				fetchedLUTs[key] = new File([blob], fetchedLUTDataList[key].fileName, { type: "text/plain" });
			});

			store.setItem(controlData.category, fetchedLUTs);
		}

		// console.log(`[FECTHED] ${controlData.control} - ${controlData.category}`);
		return fetchedLUTs;
	}

	areRequiredLUTsLoaded() {
		let status = true;
		for (let LUTcategory in this.loaded) {
			if (this.loaded[LUTcategory].required && !this.loaded[LUTcategory].status) {
				status = false;
			}
		}

		return status;
	}

	getComposerIndexByName(control, category, name) {
		let composerIndex;
		this[control][category].forEach(LUT => {
			if (LUT.title == name && LUT.status !== "deleted") composerIndex = LUT.composerIndex;
		});
		return composerIndex;
	}

	getComposerIndexById(control, id) {
		let composerIndex;

		Object.keys(this[control]).forEach(folderId => {
			this[control][folderId].forEach(lut => {
				if (lut.lutId == id) composerIndex = lut.composerIndex;
			})
		})

		return composerIndex;
	}

	getFileById(control, id) {
		let file;

		Object.keys(this[control]).forEach(folderId => {
			this[control][folderId].forEach(lut => {
				if (lut.lutId == id) file = lut.file;
			})
		})

		return file;
	}

	async load(LUTList, storeArray = []) {
		let loadedList = [];

		for await (const LUT of LUTList) {
			await new Promise(resolve => {
				let objectURL = URL.createObjectURL(LUT);
				new LUTCubeLoader().load(objectURL, t => {
					t.minFilter = LinearFilter;
					t.magFilter = LinearFilter;

					let result = {
						texture: t
					};
					result.filename = LUT.name;
					result.title = LUT.name.split(".").filter((value, key) => key < LUT.name.split(".").length - 1).join(".");
					if (result.title.split("_").length > 1) {
						result.title = result.title.split("_")[1];
					}

					// console.log(result);
					storeArray.push(result);
					loadedList.push(result);
					URL.revokeObjectURL(objectURL);
					resolve();
				});
			})
		}

		return loadedList;
	}

}
